import React from 'react';
import { Route, Routes } from 'react-router-dom';
import stdLister from '../../containers/instances/lister';
import stdEditor from '../../containers/instances/stdeditor';
import services from '../../containers/services';
import meta from '../../meta';
import LinkComponent from '../windowsManager/link';
import MainLayout from './MainLayout';
import Logout from '../Login/Logout';
import Error404 from '../blanks/errors/Error404';
import EmailDetail from '../blanks/email/email-detail/EmailDetail';
import Compose from '../blanks/email/compose/Compose';
import Inbox from '../blanks/email/inbox/Inbox';
import ReportsPanel from '../../containers/reportsPanel';
import StdRouterReportEditor from '../../containers/basicReport';
import Settings from '../blanks/pages/user/settings/Settings';
import ChangePassword from '../Login/changePassword';

function AppRouter() {
  return (
    <Routes>
      {/* <Route path="landing" element={<Landing />} /> */}
      {/* <Route element={<ErrorLayout />}> */}
      {/*  <Route path="errors/404" element={<Error404 />} /> */}
      {/*  <Route path="errors/500" element={<Error500 />} /> */}
      {/* </Route> */}
      {/* //--- MainLayout Starts  */}

      <Route path="/" element={<MainLayout />}>
        <Route
          path="/logout/"
          element={<Logout />}
        />

        {/* CATALOGS */}
        {Object.keys(meta.cat)
          .filter((cName) => !!stdLister.cat[cName])
          .map((cName) => (
            <Route
              key={`cat-list-${cName}`}
              path={meta.cat[cName].frontendURL}
              element={(
                <LinkComponent
                  component={stdLister.cat[cName]}
                  title={`Список "${meta.cat[cName].name}" `}
                />
            )}
            />
          ))}
        {Object.keys(meta.cat)
          .filter((cName) => !!stdEditor.cat[cName])
          .map((cName) => (
            <Route
              key={`cat-editor-${cName}`}
              path={`${meta.cat[cName].frontendURL}:id`}
              element={(
                <LinkComponent
                  component={stdEditor.cat[cName]}
                  title={`Елем.дов. "${meta.cat[cName].name} "`}
                />
            )}
            />
          ))}

        {/* documents */}
        {Object.keys(meta.doc)
          .filter((cName) => !!stdLister.doc[cName])
          .map((cName) => (
            <Route
              key={`doc-list-${cName}`}
              path={meta.doc[cName].frontendURL}
              element={(
                <LinkComponent
                  component={stdLister.doc[cName]}
                  title={`Список "${meta.doc[cName].name}" `}
                />
            )}
            />
          ))}
        {Object.keys(meta.doc)
          .filter((cName) => !!stdEditor.doc[cName])
          .map((cName) => (
            <Route
              key={`doc-editor-${cName}`}
              exact
              path={`${meta.doc[cName].frontendURL}:id`}
              element={(
                <LinkComponent
                  component={(
                      stdEditor.doc[cName]
                   )}
                  title={`Документ "${meta.doc[cName].name} "`}
                />
            )}
            />
          ))}
        {/* REPORTS */}

        <Route
          exact
          path="/rep/"
          element={(
            <LinkComponent
              component={ReportsPanel}
              title="Панель звітів"
            />
        )}
        />

        {Object.keys(meta.rep).map((dName) => (
          <Route
            key={`rep-el-${dName}`}
            exact
            path={meta.rep[dName].frontendURL}
            element={(
              <LinkComponent
                component={stdEditor.rep[dName]}
                title={`Звіт "${meta.rep[dName].name}" `}
              />
            )}
          />
        ))}
        <Route
          exact
          path="/rep/:reportName"
          element={(
            <LinkComponent
              component={ReportsPanel}
              title="Панель звітів"
            />
          )}
        />
        <Route
          exact
          path="/rep/:reportName/:id"
          element={(
            <LinkComponent
              component={StdRouterReportEditor}
              title="Звіт"
            />
          )}
        />

        {/* services */}
        {Object.keys(meta.srv)
          .filter((cName) => !!services[cName].Editor)
          .map((sName) => (
            <Route
              key={`srv-editor-${sName}`}
              exact
              path={meta.srv[sName].frontendURL}
              element={(
                <LinkComponent
                  component={services[sName].Editor}
                  title={meta.srv[sName].name}
                  leftToolBar={meta.srv[sName].leftToolBar}
                />
              )}
            />
          ))}

        {/* Navigation */}

        {/* Email */}
        <Route
          key="email-detail"
          exact
          path="email/email-detail/:id"
          element={(
            <LinkComponent
              component={EmailDetail}
              title="Повідомлення"
            />
            )}
        />
        <Route
          key="email-inbox"
          path="email/inbox"
          element={(
            <LinkComponent
              component={Inbox}
              title="Список повідомлень"
            />
            )}
        />
        <Route
          key="email-compose"
          path="email/compose/:id"
          element={(
            <LinkComponent
              component={Compose}
              title="Повідомлення"
            />
            )}
        />

        {/* User */}
        <Route
          key="user-settings"
          path="user/settings"
          element={(
            <LinkComponent
              component={Settings}
              title="Налаштування користувача"
            />
            )}
        />
        <Route
          key="user-changePassword"
          path="changePassword"
          element={(
            <LinkComponent
              component={ChangePassword}
              title="Налаштування користувача"
            />
            )}
        />

        <Route path="*" element={<Error404 />} />

      </Route>
    </Routes>
  );
}

export default AppRouter;
